// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

export default makeStyles()((theme: Theme) => ({
  card: {
    width: '100%',
    height: '100%',
  },
  cardTransparent: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  cardMedia: {
    height: 140,
  },
  cardMediaLarge: {
    height: 200,
  },
  cardMediaLargeOverlay: {
    height: 200,
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
  },
  cardMediaText: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: 15,
  },
  cardTitle: {
    color: theme.palette.primary.contrastText,
    fontSize: 14,
  },
  cardText: {
    color: theme.palette.primary.contrastText,
    fontSize: 12,
  },
}));
